import { Type } from 'class-transformer';
import { IsArray, IsNumber, IsOptional, ValidateNested } from 'class-validator';
import { MessageDto } from './message.dto';

export class MessageSearchResponseDto {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => MessageDto)
  docs: MessageDto[];
  @IsOptional()
  @IsNumber()
  lastPage: number;
}
